import React from 'react';
import { Card, Calendar, Badge } from 'antd';

const TaskCalendar = ({ calendar, selectedDate, onDateSelect }) => {
  // 日历事件渲染
  const getListData = (value) => {
    const dateStr = value.format('YYYY-MM-DD');
    return calendar.filter(item => item.date === dateStr);
  };

  const cellRender = (current, info) => {
    if (info.type !== 'date') return info.originNode;
    
    const listData = getListData(current);
    return (
      <ul className="events">
        {listData.map(item => (
          <li key={item.title}>
            <Badge 
              status={item.type === 'meeting' ? 'processing' : 
                     item.type === 'deadline' ? 'error' : 'success'} 
              text={item.title} 
            />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Card title="任务日历" className="mb-4">
      <Calendar
        fullscreen={false}
        cellRender={cellRender}
        onSelect={onDateSelect}
        value={selectedDate}
      />
    </Card>
  );
};

export default TaskCalendar;